module.exports = __webpack_public_path__ + "static/media/23-1.c6a3cd3f.mp3";